"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var SignalColors;

(function (SignalColors) {
  SignalColors["default"] = "GREY[\"400\"]";
  SignalColors["success"] = "UTILITY.SUCCESS";
  SignalColors["danger"] = "UTILITY.ERROR";
  SignalColors["warning"] = "UTILITY.WARN";
  SignalColors["action"] = "UTILITY.ACTION";
})(SignalColors || (SignalColors = {}));

var sonar = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
var smallSignal = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  width: 0.25rem;\n  height: 0.25rem;\n"], ["\n  width: 0.25rem;\n  height: 0.25rem;\n"])));

var makeSignalColorStyles = function makeSignalColorStyles(color, theme) {
  return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), ui_helper_deep_branding_1.getFromTheme("COLOR." + SignalColors[color], theme));
};

var makeHaloStyles = function makeHaloStyles(color, theme) {
  return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  box-shadow: 0 0 0.5rem ", ";\n"], ["\n  box-shadow: 0 0 0.5rem ", ";\n"])), ui_helper_deep_branding_1.getFromTheme("COLOR." + SignalColors[color], theme));
};

var makeSonarStyles = function makeSonarStyles(color, theme) {
  return styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  animation: ", " 2s infinite ease-in-out;\n  box-shadow: 0 0 0.5rem ", ";\n"], ["\n  animation: ", " 2s infinite ease-in-out;\n  box-shadow: 0 0 0.5rem ", ";\n"])), sonar, ui_helper_deep_branding_1.getFromTheme("COLOR." + SignalColors[color], theme));
};

exports.Root = styled_components_1.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['colorPattern', 'size', 'isHalo', 'isSonar'].includes(prop);
  }
})(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  height: 0.5rem;\n  width: 0.5rem;\n  border-radius: 50%;\n  ", "\n  ", ";\n\n  &::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    ", ";\n    ", ";\n  }\n"], ["\n  display: inline-flex;\n  height: 0.5rem;\n  width: 0.5rem;\n  border-radius: 50%;\n  ", "\n  ", ";\n\n  &::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.size === 'small' && smallSignal;
}, function (props) {
  return ui_helper_props_to_styles_1.makeStyles(props, 'colorPattern', makeSignalColorStyles);
}, function (props) {
  return props.isSonar && ui_helper_props_to_styles_1.makeStyles(props, 'colorPattern', makeSonarStyles);
}, function (props) {
  return props.isHalo && ui_helper_props_to_styles_1.makeStyles(props, 'colorPattern', makeHaloStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;